export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["إذا قمت بإلغاء الصفقة، سيتم إغلاقها دون إكمال العملية."])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["هل أنت متأكد أنك تريد إلغاء الصفقة؟"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["نعم، إلغاء"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["لا، إبقاء نشطة"])}
}